import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { gamesAPI } from "../api/api";
import { GamesActionTypes } from "../actions/actionTypes";

function* getSubsidiaryConfigurations(action) {
    try {
        let search = {};
        if (action.payload.subsidiary)
            search["subsidiary"] = action.payload.subsidiary;

        const configurations = yield call(() =>
            gamesAPI.getSubsidiaryConfigs(action.payload.subsidiary)
        );

        yield put({
            type: GamesActionTypes.GET_SUBSIDIARY_CONFIGURATIONS_SUCCESS,
            payload: {
                configurations: configurations.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting Games list.");

        yield put({
            type: GamesActionTypes.GET_SUBSIDIARY_CONFIGURATIONS_FAIL,
            message: e.message
        });
    }
}

export function* getSubsidiaryConfigurationsWatcher() {
    yield takeLatest(
        GamesActionTypes.GET_SUBSIDIARY_CONFIGURATIONS,
        getSubsidiaryConfigurations
    );
}
